import axios from 'axios';

const userStore = {
  state: {
    user: null,
    users: [],
    usersCached: new Map(),
    trade: null,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
  },
  getters: {
    getJWTToken: state => (state.user ? state.user.signInUserSession.idToken.jwtToken : null),
    getCurrentUser: state => state.user,
  },
  actions: {
    async searchUsers(context, data) {
      return axios.get(
        `${window.BASE_API.ONBOARDING_USERS}/admin/user/${data.query}`,
      )
        .then((response) => {
          // parse UserService data to match the legacy backend search output
          response.data = [
            {
              id: response.data.userMetaData.user_id,
              first_name: response.data.userMetaData.data.naturalUser.firstName,
              last_name: response.data.userMetaData.data.naturalUser.lastName,
              email: response.data.congnitoUserData.email,
            },
          ];

          return response.data;
        })
        .catch(error => Promise.reject(error));
    },
    async getUserById(context, userId) {
      return axios.get(
        `${window.BASE_API.ONBOARDING_USERS}/admin/user/${userId}`,
      ).then(response => response.data).catch(error => Promise.reject(error));
    },
    async getUserByIdCached(context, userId) {
      let promise;
      if (userStore.state.usersCached.has(userId)) {
        promise = await userStore.state.usersCached.get(userId);
      } else {
        promise = userStore.actions.getUserById(context, userId);

        userStore.state.usersCached.set(userId, promise);
      }

      return promise;
    },
    async getUserSigningsById(context, userId) {
      return axios.get(
        `${window.BASE_API.USERS}/signings/${userId}`,
      ).then(response => response.data).catch(error => Promise.reject(error));
    },
    async updateUserData(context, data) {
      return axios.post(
        `${window.BASE_API.USERS}/update/${data.id}`,
        data,
      );
    },
  },
};

export default userStore;



// WEBPACK FOOTER //
// ./src/store/users/userStore.js